




































































import { TTutorialPage, tutorialPages, TContentsLink, contentsPage } from "@/tutorial";
import Vue from 'vue';

export default Vue.extend({
  name: 'tutorial',
  data() {
    return {
      pages: tutorialPages as TTutorialPage[],
      page: 0 as number,

      contents: contentsPage as TContentsLink[],
      contentsPerPage: 10,
      contentsPage: 0,
      showContents: false
    }
  },
  computed: {
    pageData: function () : TTutorialPage {
      return this.pages[this.page];
    },

    nContentsPages: function () : number {
      return Math.ceil(this.contents.length / this.contentsPerPage);
    },

    contentsSlice: function () : TContentsLink[] {
      return this.contents.slice(
        this.contentsPage * this.contentsPerPage, 
        (this.contentsPage + 1) * this.contentsPerPage
      );
    }
  },
  methods: {
    nextPage: function () {
      if (this.pages.length > this.page + 1) {
        this.page++;
      }
    },

    prevPage: function () {
      if (this.page > 0) {
        this.page--;
      }
    },

    openContents: function () {
      this.contentsPage = Math.floor(this.page / 10);
      this.showContents = true;
    },

    navigateTo: function (page: TContentsLink) {
      this.page = page.index;
    }
  },

  created: function () {
    this.page = JSON.parse(localStorage.getItem('tutorial') ?? "0");
  },

  watch: {
    page: function () {
      this.showContents = false;
      localStorage.setItem('tutorial', JSON.stringify(this.page));

      this.$nextTick(() => {
        (this.$refs.container as HTMLElement).scrollTo({
          top: 0,
          behavior: 'auto'
        });
      })
      
    }
  }
})
